import { FirebaseApp } from 'firebase/app';
import { Platform } from './platform';
import { EMPTY } from 'rxjs';
import { Auth } from 'firebase/auth';

export class AuthConfig {
	domain?: string;

	provider?: string;

	clientId?: string;

	refreshDays?: number;

	scopes?: string[];

	redirectUri?: string;

	logoutUri?: string;

	isMobile?: boolean;

	restrictMobileUrls?: boolean;

	notifyBeforeExp?: number; // minutes

	checkExpiring?: boolean;

	quickStart?: boolean;

	preserveRoute?: boolean;

	auth?: Auth;
}

export class WebPlatform implements Platform {
	private readonly AUTH_STORAGE_KEY_PREFIX = 'ss-oauth';

	private readonly config: AuthConfig;

	private readonly base: string;

	constructor(config: AuthConfig) {
		this.config = config;
		this.base = `${this.AUTH_STORAGE_KEY_PREFIX}-${this.config.clientId}-`;
	}

	public async get(key: string): Promise<string> {
		return window.localStorage.getItem(this.base + key);
	}

	public set(key: string, value: string) {
		window.localStorage.setItem(this.base + key, value);
	}

	public remove(key: string) {
		window.localStorage.removeItem(this.base + key);
	}

	// browser
	public open(url: string) {
		window.location.href = url;
		return EMPTY;
	}

	public reopen(url: string) {
		return this.open(url);
	}
}
